var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"version-tip",class:_vm.msgStyle},[_c('div',[_c('h5',[_vm._v(_vm._s(_vm.title))]),_vm._v(" "+_vm._s(_vm.tipMsg)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }